import React from 'react';
/*eslint-disable*/
export const CalendarIcon = () => <svg width="12" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M10.8 1.273h-.6V0H9v1.273H3V0H1.8v1.273h-.6c-.66 0-1.2.572-1.2 1.272v10.182C0 13.427.54 14 1.2 14h9.6c.66 0 1.2-.573 1.2-1.273V2.545c0-.7-.54-1.272-1.2-1.272zm0 11.454H1.2V4.455h9.6v8.272z"
    fill="#919191"/>
</svg>;
